import star from "../assets/graphics/michelle-star.png";
import starcluster from "../assets/graphics/michelle-starcluster.png";
import unicorn from "../assets/graphics/michelle-unicorn.png";
import p01 from "../assets/photos/mh_1.jpg";
import p10 from "../assets/photos/mh_10.jpg";
import p11 from "../assets/photos/mh_11.jpg";
import p12 from "../assets/photos/mh_12.jpg";
import p13 from "../assets/photos/mh_13.jpg";
import p14 from "../assets/photos/mh_14.jpg";
import p15 from "../assets/photos/mh_15.jpg";
import p16 from "../assets/photos/mh_16.jpg";
import p17 from "../assets/photos/mh_17.jpg";
import p18 from "../assets/photos/mh_18.jpg";
import p19 from "../assets/photos/mh_19.jpg";
import p02 from "../assets/photos/mh_2.jpg";
import p20 from "../assets/photos/mh_20.jpg";
import p21 from "../assets/photos/mh_21.jpg";
import p22 from "../assets/photos/mh_22.jpg";
import p23 from "../assets/photos/mh_23.jpg";
import p03 from "../assets/photos/mh_3.jpg";
import p04 from "../assets/photos/mh_4.jpg";
import p05 from "../assets/photos/mh_5.jpg";
import p06 from "../assets/photos/mh_6.jpg";
import p07 from "../assets/photos/mh_7.jpg";
import p08 from "../assets/photos/mh_8.jpg";
import p09 from "../assets/photos/mh_9.jpg";

const desktop = [
  // col/row are 1-based grid lines on a 24-col grid
  // Top Row
  {
    id: "p09",
    src: p09,
    alt: "Studio portrait by Michelle Heppner, Montreal photographer",
    col: 2,
    colSpan: 2,
    row: 4,
    rowSpan: 3,
  },
  {
    id: "p16",
    src: p16,
    alt: "Wedding photography by Michelle Heppner, Montreal photographer",
    col: 5,
    colSpan: 6,
    row: 1,
    rowSpan: 5,
  },
  {
    id: "p06",
    src: p06,
    alt: "Outdoor wedding portrait by Michelle Heppner, Montreal photographer",
    col: 12,
    colSpan: 3,
    row: 3,
    rowSpan: 5,
  },
  {
    id: "p07",
    src: p07,
    alt: "Wedding film aesthetic by Michelle Heppner, Montreal photographer",
    col: 17,
    colSpan: 3,
    row: 2,
    rowSpan: 3,
  },
  {
    id: "p08",
    src: p08,
    alt: "Nature portrait photography by Michelle Heppner, Montreal photographer",
    col: 21,
    colSpan: 3,
    row: 1,
    rowSpan: 5,
  },
  // row 2
  {
    id: "p01",
    src: p01,
    alt: "Lifestyle portrait photography by Michelle Heppner, Montreal photographer",
    col: 3,
    colSpan: 5,
    row: 11,
    rowSpan: 5,
  },
  {
    id: "p19",
    src: p19,
    alt: "Black and white engagement shoot photography by Michelle Heppner, Montreal photographer",
    col: 9,
    colSpan: 2,
    row: 12,
    rowSpan: 3,
  },
  {
    id: "star",
    src: star,
    alt: "Star illustration",
    col: 13,
    colSpan: 1,
    row: 12,
    rowSpan: 2,
    clickable: false,
  },
  {
    id: "p15",
    src: p15,
    alt: "Classic wedding photography by Michelle Heppner, Montreal photographer",
    col: 16,
    colSpan: 7,
    row: 8,
    rowSpan: 6,
  },
  // row 3
  {
    id: "p14",
    src: p14,
    alt: "Studio wedding photography by Michelle Heppner, Montreal photographer",
    col: 2,
    colSpan: 2,
    row: 20,
    rowSpan: 3,
  },
  {
    id: "starcluster",
    src: starcluster,
    alt: "Cluster of stars illustration",
    col: 4,
    colSpan: 1,
    row: 23,
    rowSpan: 2,
    clickable: false,
  },
  {
    id: "p23",
    src: p23,
    alt: "Studio wedding photography by Michelle Heppner, Montreal photographer",
    col: 6,
    colSpan: 7,
    row: 19,
    rowSpan: 5,
  },
  {
    id: "p03",
    src: p03,
    alt: "Destination wedding photography by Michelle Heppner, Montreal photographer",
    col: 14,
    colSpan: 2,
    row: 17,
    rowSpan: 3,
  },
  {
    id: "p05",
    src: p05,
    alt: "Summer wedding photography by Michelle Heppner, Montreal photographer",
    col: 20,
    colSpan: 4,
    row: 18,
    rowSpan: 6,
  },
  // Row 4
  {
    id: "p18",
    src: p18,
    alt: "Wedding ceremony photography by Michelle Heppner, Montreal photographer",
    col: 2,
    colSpan: 7,
    row: 29,
    rowSpan: 5,
  },
  {
    id: "p13",
    src: p13,
    alt: "Family newborn photography by Michelle Heppner, Montreal photographer",
    col: 10,
    colSpan: 4,
    row: 31,
    rowSpan: 3,
  },
  {
    id: "p10",
    src: p10,
    alt: "Studio portrait photography by Michelle Heppner, Montreal photographer",
    col: 15,
    colSpan: 4,
    row: 24,
    rowSpan: 6,
  },
  {
    id: "unicorn",
    src: unicorn,
    alt: "Unicorn illustration",
    col: 17,
    colSpan: 2,
    row: 34,
    rowSpan: 3,
    clickable: false,
  },
  {
    id: "p22",
    src: p22,
    alt: "Bride photography by Michelle Heppner, Montreal photographer",
    col: 21,
    colSpan: 2,
    row: 31,
    rowSpan: 3,
  },
  // Row 5
  {
    id: "p02",
    src: p02,
    alt: "Film wedding photography by Michelle Heppner, Montreal photographer",
    col: 5,
    colSpan: 4,
    row: 39,
    rowSpan: 7,
  },
  {
    id: "p21",
    src: p21,
    alt: "First look photography by Michelle Heppner, Montreal photographer",
    col: 11,
    colSpan: 2,
    row: 37,
    rowSpan: 3,
  },
  {
    id: "p11",
    src: p11,
    alt: "Black and white wedding photography by Michelle Heppner, Montreal photographer",
    col: 12,
    colSpan: 3,
    row: 43,
    rowSpan: 5,
  },
  {
    id: "p17",
    src: p17,
    alt: "Bridal party photography by Michelle Heppner, Montreal photographer",
    col: 16,
    colSpan: 8,
    row: 38,
    rowSpan: 6,
  },
  // Row 6
  {
    id: "p04",
    src: p04,
    alt: "Destination wedding film photography by Michelle Heppner, Montreal photographer",
    col: 2,
    colSpan: 3,
    row: 49,
    rowSpan: 5,
  },
  {
    id: "star2",
    src: star,
    alt: "Star illustration",
    col: 10,
    colSpan: 1,
    row: 44,
    rowSpan: 4,
    clickable: false,
  },
  {
    id: "p12",
    src: p12,
    alt: "Outdoor engagement shoot by Michelle Heppner, Montreal photographer",
    col: 7,
    colSpan: 7,
    row: 51,
    rowSpan: 8,
  },
  {
    id: "p20",
    src: p20,
    alt: "Nature wedding photography by Michelle Heppner, Montreal photographer",
    col: 18,
    colSpan: 4,
    row: 49,
    rowSpan: 9,
  },
];

const photos = { desktop };
export default photos;

// export default { desktop };
